module.exports = __webpack_public_path__ + "static/Hedgehog-02bc8aca970b9ec62387689692e1bd32.png";